import * as React from "react";
import Tag from "../../../../generic/tag";
import { FTChipColorKeyComb, FTScrollStyle } from "../../ftConstants";
import SlideUpPopup from "../../../../generic/slideUpPopup";
import EdButton from "../../../../generic/edButton";
import { AFTVerifyPayin } from "../../../../service/fundTransfer/fundTransferApiService";
import moment from "moment";
import dateTimeFormat from "../../../../service/dateTimeService";
import { toINR } from "../../../../service/numberFormat";

export interface IFtHistoryTblPayInMobProps {
	data: Array<any>;
}

const FtHistoryTblPayInMob: React.FC<IFtHistoryTblPayInMobProps> = (props) => {
	// isAccordianOpen = if row is open then it stores rowIndex otherwise -1
	const [isPopupOpen, setIsPopupOpen] = React.useState<number>();
	function verifyRes(res: any) {
		// console.log(res);
	}

	const PayInVerify = (instNo: string) => {
		AFTVerifyPayin(verifyRes, { instNo });
	};

	return (
		<div className="ft_hist_table">
			<ul
				className={"ft_his_data " + (props.data.length > 0 ? "ftScrollCont" : "")}
				style={FTScrollStyle(props.data.length > 0 ? true : false)}
			>
				{props.data.map((row, index) => {
					return (
						<React.Fragment key={index}>
							<li className="ft_his_row" onClick={() => setIsPopupOpen(index)}>
								<div className="fl_his">
									<div className="fl_row1">
										<div className="col amount">₹{toINR(row.trnsAmt)}</div>
										<div className="col status">
											<Tag value={row.sts} color={FTChipColorKeyComb[row.sts.toLowerCase()]} />
										</div>
									</div>
									<div className="fl_row2">
										<div className="col date_time">
											<label className="tm">{moment(row.tm, ["h:mm A"]).format("HH:mm:ss")} </label>
											<label> {moment(dateTimeFormat(row.dt, " ")).format("DD MMM 'YYYY")}</label>
										</div>
										<div className="col bank">{row.bnkName}</div>
									</div>
								</div>
							</li>
							{isPopupOpen === index && (
								<SlideUpPopup closePopup={() => setIsPopupOpen(undefined)}>
									<div className="ftHistory_pop_cont">
										<button className="cls" onClick={() => setIsPopupOpen(undefined)}>
											<i className="edel-icon-close"></i>
										</button>
										<div className="bank_amt_Sec ft_dtl_sec">
											<div className="col amt_sts">
												<div className="amount">₹{toINR(row.trnsAmt)}</div>
												<div className="status">
													<Tag value={row.sts} shape="chip" color={FTChipColorKeyComb[row.sts.toLowerCase()]} />
												</div>
											</div>
											<div className="col bank">{row.bnkName}</div>
											<div className="col date_time">
												<label className="date"> {moment(dateTimeFormat(row.dt, " ")).format("DD MMM 'YYYY")}</label>
												<label className="fl_circle"></label>
												<label className="tm">{moment(row.tm, ["h:mm A"]).format("HH:mm:ss")} </label>
											</div>
										</div>
										<div className="acc_sec ft_dtl_sec">
											<div className="data_con">
												<label className="txt">Bank A/C</label>
												<label className="val">{row.bnkAccNo}</label>
											</div>
											<div className="data_con">
												<label className="txt">Ref No.</label>
												<label className="val">{row.instNo}</label>
											</div>
											<div className="data_con">
												<label className="txt">Mode</label>
												<label className="val">{row.payMd}</label>
											</div>
											{row.upi && (
												<div className="data_con">
													<label className="txt">UPI ID</label>
													<label className="val">{row.upi}</label>
												</div>
											)}
											<div className="data_con">
												<label className="txt">Ledger</label>
												<label className="val">{row.ldgrNm}</label>
											</div>
										</div>
										{row.sts.toLowerCase() === "failed" && (
											<div className="remark_sec ft_dtl_sec">
												<label className="rmrk_tit">Remarks</label>
												<label className={"rmrk_val " + (row.sts.toLowerCase() === "failed" ? "red" : "")}>{row.rmk}</label>
												{row.verify === "true" && (
													<EdButton
														value="Verify Status"
														btnTyp="link"
														className="showDetls refsh_btn"
														onClick={() => PayInVerify(row.instNo)}
													/>
												)}
											</div>
										)}
									</div>
								</SlideUpPopup>
							)}
						</React.Fragment>
					);
				})}
			</ul>
		</div>
	);
};

export default FtHistoryTblPayInMob;
